import React, { useRef, useState } from 'react';
import './RadialMenu.css';
import HexagonButton from '../../components/HexagonButton/HexagonButton';
import DoorOpenIcon from "../../assets/elevator-door-open.png";
import DoorCloseIcon from "../../assets/eleveator-door-closed.png"
import ElevatorIcon from "../../assets/elevator-central-image.png"
import DownArrow from "../../assets/down-arrow.png";
import UpArrow from "../../assets/up-arrow.png";
import InfoIcon from "../../assets/info.png";
import CameraIcon from "../../assets/icon_device_camera.png";
import ElevatorInfoPopup from '../ElevatorInfoPopup/ElevatorInfoPopup';
import CameraView from '../CameraView';
import {useNavigate} from "react-router-dom";


// Menu items configuration
const menuItems = [
  { id: "doors-button", label: 'DOORS', imageSrc: DoorOpenIcon, imageSrc2: DoorCloseIcon },
  { id: "direction-button", label: 'DIRECTION', imageSrc: UpArrow, imageSrc2: DownArrow },
  { id: "camera-button", label: 'CAMERA', imageSrc: CameraIcon },
  { id: "position-button", label: 'POSITION' },
  { id: "info-button", label: '', imageSrc: InfoIcon },
];



// Temperature gauge configuration
const tempGaugeSVG = [
  { id: 10, svgPath: "M -206 3 C -206 -19 -205 -24 -206 -10 L -187 -10 C -187 -17 -187 -19 -187 3 Z" },
  { id: 20, svgPath: "M -206 3 C -206 -19 -205 -24 -204 -28 L -186 -23 C -187 -17 -187 -19 -187 3 Z" },
  { id: 30, svgPath: "M -206 3 C -206 -19 -203 -44 -200 -44 L -182 -39 C -186 -37 -187 -19 -187 3 Z" },
  { id: 40, svgPath: "M -206 3 C -206 -19 -203 -44 -195 -60 L -177 -53 C -186 -37 -187 -19 -187 3 Z" },
  { id: 50, svgPath: "M -206 3 C -206 -19 -204 -45 -186 -76 L -171 -65 C -186 -37 -187 -19 -187 3 Z" },
  { id: 60, svgPath: "M -206 3 C -206 -19 -209 -45 -175 -92 L -161 -81 C -191 -37 -187 -19 -187 3 Z" },
  { id: 70, svgPath: "M -206 3 C -206 -19 -209 -65 -157 -109 L -145 -96 C -191 -52 -187 -19 -187 3 Z" },
  { id: 80, svgPath: "M -206 3 C -206 -19 -207 -79 -139 -122 L -130 -105 C -190 -67 -187 -19 -187 3 Z" },
  { id: 90, svgPath: "M -206 3 C -206 -19 -207 -85 -135 -125 L -126 -108 C -190 -72 -187 -19 -187 3 Z" },
  { id: 100, svgPath: "M -206 3 C -206 -19 -207 -90 -124 -131 L -115 -114 C -190 -77 -187 -19 -187 3 Z" }
]

// Temperature gauge value-to-svg selector
const selectTemperatureSVGPath = (temperature) => {
  const selectedPath = tempGaugeSVG.find(entry => entry.id >= temperature);
  return selectedPath ? selectedPath.svgPath : '';
};

const RadialMenu = ({ device }) => {
  const [showPopupMenu, setShowPopupMenu] = useState(false);
  const [showCameraView, setShowCameraView] = useState(false);
  // Placeholder for default image, replace 'path_to_some_default_image' with your actual default image path
  const defaultImage = 'path_to_some_default_image';

  const navigate = useNavigate();

  // Toggle camera view modal instead of opening a new window
  const toggleCameraView = () => {
    setShowCameraView(!showCameraView);
  };

  const openInfoPopupWindow = () => {
    setShowPopupMenu(true);
  };
  
  const closeInfoPopupWindow = () => {
    setShowPopupMenu(false);
  };

  const goToDeviceStatistics = () => {
    navigate(`/buildings/${device.buildingId}/banks/${device.bankId}/devices/${device.deviceId}`);
  };

  // Function to close the radial menu when click outside of the menu, may be modified after having the radial right menu
  // Update - October. 15, 2024 -> Commented this function for now as it closed the radial menu even if another device was clicked from the device card.
  const menuRef = useRef(null);
  // const { onClose } = props;
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  // if (menuRef.current && !menuRef.current.contains(event.target)) {
  //   onClose();
  // }
  //   };

  //   document.addEventListener('click', handleClickOutside);

  //   return () => {
  //     document.removeEventListener('click', handleClickOutside);
  //   };
  // }, [onClose]);

  return (
    <div className="radial-menu-container" ref={menuRef}>
      <div className='outer-ring'>
        <div className="radial-menu">
          <div className="temperature-gauge height=auto">
            <svg className="temperature-container" viewBox="280 360 200 240" xmlns="http://www.w3.org/2000/svg">
              <path d={'M440.739 367l-18.253 9.174C353.717 410.736 311 480.167 311 557.373v20.621l40.82-.115V557.373a160.821 160.821 0 0 1 88.93-144.521L459 403.677Zm-1.513 42.8a164.221 164.221 0 0 0-90.811 147.578v17.1l-34.017.1V557.373c0-75.9 42-144.164 109.61-178.143l15.211-7.645 15.218 30.565'} />
            </svg>
            <svg className="temperature-value" viewBox="-280 -140 175 270" xmlns="http://www.w3.org/2000/svg">
              <path className="temperature-value-svg" d={selectTemperatureSVGPath(device.infoMessage.temperature)} fill="none" />
            </svg>
            <div>
              <h3 className="temp-info-celsius">{device.infoMessage.temperature}°C</h3>
              <h3 className="temp-info-farenheit">{device.infoMessage.temperature * 9 / 5 + 32}°F</h3>
            </div>
          </div>


          {/* Map over the menuItems to render HexagonButtons */}
          {menuItems.map((item, index) => (
            <div key={index} className="menu-item-container">

              <HexagonButton
                className={item.id}
                  // If doorStatus is 20, the door is closed
                imgSrc={index === 0 && Number(device.infoMessage.door) === 20 ? undefined : item.imageSrc}
                  // If doorStatus is 10, the door is opened
                imgSrc2={index === 0 && Number(device.infoMessage.door) === 10 ? undefined : item.imageSrc2}
                floorLevel={index === 3 ? device.infoMessage.location : undefined}
                label={item.label}
                direction={index === 1 ? device.infoMessage.direction : undefined}
                onClick={index === 2 ? toggleCameraView : index === 4 ? openInfoPopupWindow : undefined}
              />

            </div>
          ))}

          <div className="third-ring">
            <div className="second-ring">
              <div className="inner-ring" onClick={goToDeviceStatistics} style={{ cursor: 'pointer' }}>
                {/* Use the imageSrc prop to dynamically set the image, or use a default if no imageSrc is provided */}
                <img src={ElevatorIcon || defaultImage} alt="Device Icon" className="device-image" />
                <div className="device-info">
                  <div><h3>{device.deviceName}</h3></div>
                  <div>DEVICE ID: {device.deviceId}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {showPopupMenu && (
        <div className='popup-menu'>
          <ElevatorInfoPopup device={device} onClose={closeInfoPopupWindow} />
        </div>
      )}
      
      {showCameraView && (
        <div className='camera-modal'>
          <div className='camera-modal-content'>
            <div className='camera-modal-header'>
              <h3>Live Camera Feed - {device.deviceName}</h3>
              <button className='close-button' onClick={toggleCameraView}>×</button>
            </div>
            <div className='camera-modal-body'>
              <CameraView 
                deviceId={device.deviceId} 
                cameraIp={device.cameraUrl} 
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};


export default RadialMenu;
